module.exports = __webpack_public_path__ + "static/media/icons8-settings.f1de9c01.svg";